import React from 'react';

const ConfirmUnassignAssetModal = ({ show, asset, onClose, onConfirm }) => {
    if (!show || !asset) return null;

    return (
        <div className="fixed inset-0 bg-black bg-opacity-50 flex items-center justify-center z-50">
            <div className="bg-white rounded-lg w-full max-w-md p-6">
                <h2 className="text-xl font-semibold mb-4 text-red-600">Unassign Asset</h2>

                <p className="mb-6 text-gray-700">
                    Are you sure you want to <strong>unassign</strong> the asset{' '}
                    <span className="font-medium">{asset.type} - {asset.serialNumber}</span>
                    from the customer?
                </p>

                <div className="flex justify-end space-x-2">
                    <button
                        onClick={onClose}
                        className="bg-gray-300 text-gray-700 px-4 py-2 rounded hover:bg-gray-400"
                    >
                        Cancel
                    </button>
                    <button
                        onClick={onConfirm}
                        className="bg-red-600 text-white px-4 py-2 rounded hover:bg-red-700"
                    >
                        Unassign
                    </button>
                </div>
            </div>
        </div>
    );
};

export default ConfirmUnassignAssetModal;
